import { DEFAULT_MAP_PROVIDER_KEY } from '../constants/mapProviders';

export const GROUPS_MAP_VIEW_MODE_KEY = 'groups:viewMode';
export const GROUPS_MAP_PROVIDER_KEY = 'groups:mapProvider';
export const GROUPS_MAP_PROVIDER_CHANGED_EVENT = 'groups:mapProviderChanged';
export const GROUPS_MAP_VIEW_MODE_CHANGED_EVENT = 'groups:viewModeChanged';

export const readGroupsViewMode = () => {
  try {
    const mode = localStorage.getItem(GROUPS_MAP_VIEW_MODE_KEY);
    return mode === 'map' ? 'map' : 'cards';
  } catch (_e) {
    return 'cards';
  }
};

export const writeGroupsViewMode = (mode) => {
  try {
    localStorage.setItem(GROUPS_MAP_VIEW_MODE_KEY, mode === 'map' ? 'map' : 'cards');
  } catch (_e) {
    // noop
  }
};

export const emitGroupsViewModeChanged = (mode) => {
  try {
    window.dispatchEvent(
      new CustomEvent(GROUPS_MAP_VIEW_MODE_CHANGED_EVENT, {
        detail: { mode: mode === 'map' ? 'map' : 'cards' },
      }),
    );
  } catch (_e) {
    // noop
  }
};

export const readGroupsMapProvider = () => {
  try {
    return localStorage.getItem(GROUPS_MAP_PROVIDER_KEY) || DEFAULT_MAP_PROVIDER_KEY;
  } catch (_e) {
    return DEFAULT_MAP_PROVIDER_KEY;
  }
};

export const writeGroupsMapProvider = (providerKey) => {
  try {
    localStorage.setItem(GROUPS_MAP_PROVIDER_KEY, providerKey || DEFAULT_MAP_PROVIDER_KEY);
  } catch (_e) {
    // noop
  }
};

export const emitGroupsMapProviderChanged = (providerKey) => {
  try {
    window.dispatchEvent(
      new CustomEvent(GROUPS_MAP_PROVIDER_CHANGED_EVENT, {
        detail: { providerKey: providerKey || DEFAULT_MAP_PROVIDER_KEY },
      }),
    );
  } catch (_e) {
    // noop
  }
};
